<script>
  import { getContext } from "svelte";
  const { scales, dimensions } = getContext("BarChart");
  export let value;
  export let rank;
  export let fill;
  const borderWidth = 4;
  $: w = $scales.x(value) || 0;
  $: y = ($scales.y(rank) || 0) + $dimensions.barMargin / 2;
  $: barColor = `--bar-color: ${fill}96;`;
  $: transform = `transform: translateY(${y}px);`;
  $: width = `width: ${w - borderWidth}px;`;
  $: height = `height: ${$dimensions.barHeight || 0}px;`;
</script>

<div style="{barColor} {transform} {width} {height}"></div>

<style>
  div {
    top: 0;
    left: 0;
    position: absolute;
    background: var(--bar-color);
    border-left: 1px solid var(--bar-color);
  }
</style>
